type AuthExpiredHandler = () => void

const handlers = new Set<AuthExpiredHandler>()

export function onAuthExpired(handler: AuthExpiredHandler): () => void {
  handlers.add(handler)
  return () => {
    handlers.delete(handler)
  }
}

export function emitAuthExpired(): void {
  for (const h of handlers) {
    try {
      h()
    } catch (error) {
      console.error('[authEvents] handler threw:', error)
    }
  }
}
